import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_completed_dock_appointmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { from_date?: string, project_id?: number, dock_appointment_carrier_id?: number, dock_appointment_type_id?: number }): 
  Promise<{ result: { Id?: number, CompletedOn?: string, LookupCode?: string, ScheduledProjectId?: number, StatusId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_dock_appointments/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { from_date?: string, project_id?: number, dock_appointment_carrier_id?: number, dock_appointment_type_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CompletedOn?: string, LookupCode?: string, ScheduledProjectId?: number, StatusId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_dock_appointments/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { from_date?: string, project_id?: number, dock_appointment_carrier_id?: number, dock_appointment_type_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CompletedOn?: string, LookupCode?: string, ScheduledProjectId?: number, StatusId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_dock_appointments/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      from_date?: string, project_id?: number, dock_appointment_carrier_id?: number, dock_appointment_type_id?: number    }) {
      return false;
    }
}
